import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Marked from 'react-markdown'

import Gallery from '../Shop/Gallery'
import './Home.css'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { story, headline } = this.props.page
    return (
      <div className="Home">
        <Helmet title={headline} />
        <div className="section">
          <div className="container skinny">
            {headline && <h3>{headline}</h3>}
            {story && <Marked source={story} />}
          </div>
        </div>
        <Gallery galleryItems={this.props.galleryItems} />
      </div>
    )
  }
}

Home.propTypes = {
  page: PropTypes.object.isRequired
}

export default Home



// WEBPACK FOOTER //
// ./src/Home/Home.js